import React, { createContext, useContext } from 'react'
import { Badge, Space } from 'antd'
import { useQuery } from '@apollo/client'
import { ShoppingCartOutlined } from '@ant-design/icons'
import { MenuLink } from '../../../core/until'
import { translate } from '../../../core'
import { ShowIf } from '../../../core/component'
import { GetReceivedBackOrderCountQuery } from '../../order/graphql/order-report-graphql'

const POLL_INTERVAL = 60_000

type ReceivedBackOrderCount = {
  count: number
  refetch: () => void
}

const ReceivedBackOrderCountContext = createContext<ReceivedBackOrderCount>({
  count: 0,
  refetch: () => undefined,
})

export const ReceivedBackOrderCountProvider = ({children}: { children: React.ReactNode }) => {
  const {data, refetch} = useQuery(GetReceivedBackOrderCountQuery, {
    pollInterval: POLL_INTERVAL,
  })

  return (
    <ReceivedBackOrderCountContext.Provider
      value={{
        count: data?.purchaseOrderBackOrderDeliverablesNewCount ?? 0,
        refetch: () => { refetch() },
      }}
    >
      {children}
    </ReceivedBackOrderCountContext.Provider>
  )
}

export const useReceivedBackOrderCount = () => useContext(ReceivedBackOrderCountContext)

const CountBadge = ({count}: { count: number }) => (
  <ShowIf
    condition={!!count}
    replacement={<></>}
  >
    <Badge count={count} color='#f5222d'/>
  </ShowIf>
)

export const ReceivedBackOrderMenuItem = () => {
  const {count} = useReceivedBackOrderCount()

  return (
    <Space>
      <MenuLink
        title={translate('received_back_orders')}
        to='/reports/received-back-orders'
      />
      <CountBadge count={count}/>
    </Space>
  )
}

export const PurchaseOrderMenuLabel = () => {
  const {count} = useReceivedBackOrderCount()

  return (
    <Space>
      {translate('purchase', 'order')}
      <CountBadge count={count}/>
    </Space>
  )
}

export const PurchaseOrderMenuIcon = () => {
  const {count} = useReceivedBackOrderCount()

  return (
    <ShoppingCartOutlined style={{fontSize: 23, color: count > 0 ? '#f5222d' : '#a3bde3'}}/>
  )
}
